import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import moment from 'moment';

import App from './App.vue';
import router from './router/index';
import SvgIcon from '@shared/components/ui/SvgIcon.vue';
import LoadingData from '@shared/components/ui/LoadingData.vue';

const pinia = createPinia();
const app = createApp(App);
app.component('svg-icon', SvgIcon);
app.component('ui-loading', LoadingData);
app.config.globalProperties.$filters = {
  momentFormat(date, format) {
    if (date) return moment(date).format(format);
    else return '---';
  },
};

app.provide('$filters', app.config.globalProperties.$filters);
app.use(router);
app.use(pinia);
app.use(ElementPlus);
app.mount('#app');
